module.exports = __webpack_public_path__ + "static/img/1.e169089.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/eng/1.png
// module id = V0vF
// module chunks = 0